import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import Seo from "../components/Seo";

const SCALE = [
  ["10", "Gem Mint", "A virtually perfect card. Sharp corners, flawless surface, and near-perfect centering."],
  ["9", "Mint", "A superb card with only one minor flaw, such as slight off-centering or a tiny print imperfection."],
  ["8", "NM-MT", "Near Mint-Mint. A card with a few minor imperfections visible on close inspection."],
  ["7", "NM", "Near Mint. Minor wear — slight fraying at a corner or a touch of off-centering."],
  ["6", "EX-MT", "Excellent-Mint. Visible surface wear or light corner touches, still a strong eye-appeal card."],
  ["5", "EX", "Excellent. Moderate corner wear and minor surface issues, but no creases."],
  ["4", "VG-EX", "Very Good-Excellent. Noticeable wear on corners and edges with light surface loss."],
  ["3", "VG", "Very Good. Rounded corners and surface wear; the card has clearly been handled."],
  ["2", "Good", "Heavy wear, possible minor creasing, but fully intact and identifiable."],
  ["1", "Poor / Fair", "Significant damage — creases, staining, or missing pieces, yet still authentic."],
];

export default function GradingScale() {
  return (
    <div className="bg-white" data-testid="grading-scale-page">
      <Seo title="Card Grading Scale 1–10 Explained" description="The trading card grading scale explained, from Gem Mint 10 down to Poor 1 — including half grades and the Authentic designation used by MAS Grading." path="/grading-scale" />
      <PageHeader eyebrow="The scale" title="The MAS grading scale" subtitle="Every card is graded on a 1–10 point scale. Half grades (e.g. 9.5) are awarded when a card falls just between two whole grades." word="1–10" />
      <section className="max-w-4xl mx-auto px-6 lg:px-8 py-20 md:py-28">
        <div className="rounded-3xl border border-neutral-200 overflow-hidden">
          {SCALE.map(([g, label, d], i) => (
            <div key={g} className={`flex items-start gap-5 p-6 ${i % 2 ? "bg-[#FAFAFA]" : "bg-white"} ${i ? "border-t border-neutral-100" : ""}`} data-testid={`scale-row-${g}`}>
              <div className="font-display font-900 text-3xl w-14 shrink-0 text-[#0A0A0A]" style={{ fontWeight: 900 }}>{g}</div>
              <div>
                <div className="font-display font-bold text-lg text-[#0A0A0A]">{label}</div>
                <p className="text-neutral-500 text-sm mt-1 leading-relaxed">{d}</p>
              </div>
            </div>
          ))}
        </div>
        <p className="text-neutral-500 text-sm mt-8">Cards that cannot be assigned a numeric grade but are confirmed genuine receive an <strong className="text-[#0A0A0A]">Authentic</strong> designation.</p>
        <div className="mt-8"><Link to="/card-grades" className="font-bold text-[#0A0A0A] underline underline-offset-4">How grades are determined →</Link></div>
      </section>
    </div>
  );
}
